
export enum MarketingVendorType {
  PersistenceOnly = 'PersistenceOnly',
  Mailchimp = 'Mailchimp',
  Mailerlite = 'Mailerlite',
}
